"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.olapicStreamItemSchema = void 0;
var _zod = require("zod");
/* eslint-disable @typescript-eslint/naming-convention -- external */

const olapicStreamItemSchema = exports.olapicStreamItemSchema = _zod.z.object({
  id: _zod.z.string(),
  name: _zod.z.string(),
  tag_based_key: _zod.z.string()
});
